import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { EmptyRow, Money, PageHeader, Panel } from "@/components/common";
import { Button } from "@/components/ui/button";

const COLORS = { draft: "bg-slate-100 text-slate-700", sent: "bg-blue-50 text-blue-800", accepted: "bg-emerald-50 text-emerald-800", declined: "bg-red-50 text-[#A50E1F]", converted: "bg-amber-50 text-amber-800" };
export const QuoteBadge = ({ status }) => { const { t } = useLang(); return <span data-testid="quote-status" className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${COLORS[status]}`}>{t(`q_${status}`)}</span>; };

export default function Quotes() {
  const { t } = useLang();
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/quotes").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const remove = async (q) => {
    if (!window.confirm(t("confirmDelete"))) return;
    try { await api.delete(`/quotes/${q.id}`); toast.success(t("deleted")); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="quotes-page">
      <PageHeader title={t("quotes")} subtitle={t("quotesSubtitle")}
        actions={<Button asChild data-testid="new-quote-btn" className="bg-[#007A3D] hover:bg-[#005E2E]"><Link to="/quotes/new"><Plus className="me-1 h-4 w-4" />{t("newQuote")}</Link></Button>} />
      <Panel className="overflow-x-auto">
        <table className="data-table">
          <thead><tr><th>{t("quoteNumber")}</th><th>{t("client")}</th><th>{t("issueDate")}</th><th>{t("validUntil")}</th><th>{t("status")}</th><th className="text-end">{t("total")}</th><th className="text-end">{t("actions")}</th></tr></thead>
          <tbody>
            {rows.length === 0 && <EmptyRow cols={7} />}
            {rows.map((q) => (
              <tr key={q.id} data-testid={`quote-row-${q.number}`} className="cursor-pointer" onClick={() => nav(`/quotes/${q.id}`)}>
                <td className="font-mono font-semibold text-slate-900">{q.number}</td>
                <td>{q.client_name}</td>
                <td className="font-mono text-slate-500">{q.issue_date}</td>
                <td className="font-mono text-slate-500">{q.due_date}</td>
                <td><QuoteBadge status={q.status} /></td>
                <td className="text-end font-semibold"><Money value={q.total} /></td>
                <td className="text-end" onClick={(e) => e.stopPropagation()}>
                  {q.status !== "converted" && <button data-testid={`delete-quote-${q.number}`} onClick={() => remove(q)} className="rounded p-1.5 text-slate-500 hover:bg-red-50 hover:text-[#CE1126]"><Trash2 className="h-4 w-4" /></button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
